// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"a45c35e1","674":"f2cc4b5b","895":"738c856e"}[chunkId] + ".chunk.js";
};